//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            selectedMap: '',
            categories: '',
            //
            generalData: {
                folder: '',
                accentColor: '',
                subtitleColor: '',
                categories: [],
                whatsappNumber: '',
                wazeIntegration: '',
                googleSheets: {
                    integration: true,
                    url: '',
                },
                emailJs: {
                    integration: false,
                    emails: '',
                },
            },
            cartSettings: {
                locationDefaults: {
                    defaultLat: '',
                    defaultLng: '',
                },
                inputData: [
                    {
                        type: '',
                        label: '',
                        required: '',
                        placeholder: '',
                        options: '',
                    },
                ],
            },
            menu: [
                {
                    title: '',
                    subtitle: '',
                    desc: '',
                    type: '',
                    pic: '',
                    price: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: '',
                            price: 0,
                        },
                    ],
                },
            ],
            //
            colorOptions: [
                {
                    label: 'Rojo',
                    value: 'red',
                },
                {
                    label: 'Rosado',
                    value: 'pink',
                },
                {
                    label: 'Morado',
                    value: 'purple',
                },
                {
                    label: 'Morado profundo',
                    value: 'deep-purple',
                },
                {
                    label: 'Indigo',
                    value: 'indigo',
                },
                {
                    label: 'Azul',
                    value: 'blue',
                },
                {
                    label: 'Celeste',
                    value: 'light-blue',
                },
                {
                    label: 'Cian',
                    value: 'cyan',
                },
                {
                    label: 'Verde azulado',
                    value: 'teal',
                },
                {
                    label: 'Verde',
                    value: 'green',
                },
                {
                    label: 'Verde claro',
                    value: 'light-green',
                },
                {
                    label: 'Lima',
                    value: 'lime',
                },
                {
                    label: 'Amarillo',
                    value: 'yellow',
                },
                {
                    label: 'Ambar',
                    value: 'amber',
                },
                {
                    label: 'Naranja',
                    value: 'orange',
                },
                {
                    label: 'Naranja profundo',
                    value: 'deep-orange',
                },
                {
                    label: 'Chocolate',
                    value: 'brown',
                },
                {
                    label: 'Gris',
                    value: 'grey',
                },
                {
                    label: 'Gris azulado',
                    value: 'blue-grey',
                },
            ],
        }
    },
    methods: {
        addCartInput() {
            this.cartSettings.inputData.push({
                type: '',
                label: '',
                required: '',
                placeholder: '',
                options: '',
            })
        },
        returnFormatedOptions(s) {
            let optionsArray = s.split(',')
            let formatedOptions = []
            optionsArray.forEach(option => {
                if (option[0] == ' ') {
                    option = option.substring(1)
                }

                let o = {}
                o.label = option
                o.value = option.replace(/\s/g, '_').toLowerCase()
                formatedOptions.push(o)
            })
            return formatedOptions
        },
        addOptionToMenuItem(i, arr) {
            let obj = {
                title: '',
                price: 0,
            }
            if (arr == 'options') this.menu[i].options.push(obj)
            if (arr == 'styles') this.menu[i].styles.push(obj)
            if (arr == 'sides') this.menu[i].sides.push(obj)
        },
        addMenuItem() {
            this.menu.push({
                title: '',
                subtitle: '',
                desc: '',
                type: '',
                pic: '',
                price: 0,
                styles: [],
                sides: [],
                options: [
                    {
                        title: '',
                        price: 0,
                    },
                ],
            })
        },
        copyToClipboard() {
            this.menu.forEach(item => {
                item.price = parseFloat(item.price)
                item.options.forEach(option => {
                    option.price = parseFloat(option.price)
                })
                item.styles.forEach(style => {
                    style.price = parseFloat(style.price)
                })
                item.sides.forEach(side => {
                    side.price = parseFloat(side.price)
                })
            })

            setTimeout(() => {
                let jsonContent = document.getElementById('menuJSON').innerHTML
                jsonContent = jsonContent.replace(/&lt;/g, '<')
                jsonContent = jsonContent.replace(/&gt;/g, '>')
                jsonContent = jsonContent.replace(/<!---->/g, '')
                jsonContent = jsonContent.replace(/<span>/g, '')
                jsonContent = jsonContent.replace(/<\/span>/g, '')
                navigator.clipboard.writeText(jsonContent).then(
                    () => {
                        alert('copiado con exito')
                    },
                    function(err) {
                        console.error('Async: Could not copy text: ', err)
                    }
                )
            }, 500)
        },
    },
    computed: {
        returnSelectedMapValue() {
            if (this.selectedMap == 'waze') return true
            else return false
        },
        returnEmailsinArray() {
            return this.generalData.emailJs.emails.replace(/\s/g, '').split(',')
        },
    },
}
